export enum PropertyType {
  PRIMITIVE = 'primitive',
  LIST = 'list',
}

export enum ListItemChangeType {
  EDIT = 'edit',
  ADD = 'add',
  DELETE = 'delete',
}

export type ChangeDetail = {
  name: string;
  oldValue?: number | string | boolean | null;
  value?: number | string | boolean | null;
};

export type PrimitiveChange = ChangeDetail & {
  type: PropertyType.PRIMITIVE;
};

export type ListItemChangeDetail = {
  type: ListItemChangeType; // edit, add or delete
  name: string; // Tire and Wheel, GAP, etc.
  changes?: ChangeDetail[]; // populated only if type === 'edit'
};

export type ListChange = {
  type: PropertyType.LIST;
  name: string; // Protections Plans, Add-Ons, Accessories
  listItemChanges?: ListItemChangeDetail[];
  oldTotal?: number;
  newTotal?: number;
};

export type PropertyChange = PrimitiveChange | ListChange;
